var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReportRawData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D8F4E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 25,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 4,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 4,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25,
    width: 4,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 4,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 25,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 5,
    height: 2,
    stroke: "#03A65B",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportRawData);
export default __webpack_public_path__ + "static/media/ic-report-raw-data.c376019e2c861684c367b70e98d12310.svg";
export { ForwardRef as ReactComponent };